<script setup lang="ts">
import TheLayout from '@/modules/shared/layouts/the-layout.vue'
import { onMounted } from 'vue'
import { useExtendedI18n } from '@/i18n'
import { capitalize } from 'lodash'
import { RouterLinkBack, VButtonInvisible } from '@/modules/shared/components'
import { useAuthStore } from '@/modules/auth/stores/auth-store'
import { useRouter, useRoute } from 'vue-router'
import DocumentForm from '../components/document-form.vue'

const { t } = useExtendedI18n()
const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()

onMounted(async () => {
  if (!authStore.is_site_or_group_admin) router.push({ name: 'dashboard' })
})
</script>

<template>
  <TheLayout>
    <div class="-mt-6 mb-6 flex items-center justify-between sm:-mt-8">
      <div>
        <RouterLinkBack :fallback="{ name: 'investing.entity.documents' }">
          <VButtonInvisible>← {{ capitalize(t('shared.back')) }}</VButtonInvisible>
        </RouterLinkBack>
      </div>
    </div>
    <div class="mb-5 text-lg">New Document</div>
    <DocumentForm :investor_type="route.params.entity_type" :investor_id="route.params.entity_id" />
  </TheLayout>
</template>
